import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get paymentMode
export const getPaymentMode = createAsyncThunk("paymentMode/getPaymentMode", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getPaymentMode({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all paymentMode
export const getAllPaymentMode = createAsyncThunk("paymentMode/getAllPaymentMode", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllPaymentMode();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("paymentMode/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("paymentMode/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "paymentMode/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPagePaymentMode({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create paymentMode
export const createPaymentMode = createAsyncThunk(
  "paymentMode/createPaymentMode",
  async (data, { rejectWithValue }) => {
    const { name, paymentType, isActive } = data;
    try {
      const body = JSON.stringify({ name, paymentType, isActive });
      const { data } = await API.createPaymentMode(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updatePaymentMode = createAsyncThunk(
  "paymentMode/updatePaymentMode",
  async (data, { rejectWithValue }) => {
    const { id, values } = data;
    const { name, paymentType, isActive } = values;
    try {
      const body = JSON.stringify({ name, paymentType, isActive });
      const { data } = await API.updatePaymentMode(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk("paymentMode/handleSearch", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
